module.exports = __webpack_public_path__ + "img/AT0000002575080.5e9c2776.png";